import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "limitLength" }

import { ref, Ref, reactive, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { formatNumber, getNumber } from '@/utils/index'
import dayjs from 'dayjs'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 获取研发工时
  'POST/project_cost_time/time': fetchList,
  // 批量按月导出研发工时表并打包压缩文件
  'POST/project_cost_time/export': exportApi,
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const searchConfig = ref([
  {
    type: "TIME",
    label: "时间",
    value: [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().endOf('month').format('YYYY-MM-DD')],
    upKey: 'dateRange',
    props: { type: 'daterange', clearable: false, },
    timeCb: (time: string): void => {
      searchHandle({...MI_params, dateRange: time})
    },
  },
  {
    label: "姓名",
    value: '',
    upKey: 'key',
    props: { placeholder: '请输入姓名' }
  }
])
let dynamicTotal: any = ref([])
const searchHandle = async (params: any) => {
  let { total } = await fetchData({
    ...params,
    dateRange: {
      from: params.dateRange?.[0],
      to: params.dateRange?.[1],
    }
  })

  dynamicTotal.value = total
}

const calculDate = computed(() => {
  return MI_tableData.value.map(e => {
    // e.ALL = e.personalTotalAmount
    e.projectList.push({data: e.personalTotalAmount, projectName: 'ALL', purpose: 'ALL'})
    return e
  })
})

// 添加
const addConfig = ref([])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async (params: any) => {
    ElMessage.success('成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 修改
const modifyFg = ref<boolean>(false)
const modifyHandle = (row: any) => { }

// 删除
const delHandle = (row: any) => { }


// ---------------
const formatProjectList = (row: any, projcet: any) => {
  let obj = row.projectList.find((e: any) => e.purpose === projcet.purpose) || { data: 0 }
  return getNumber(obj.data)
}
const getSummaries = (param: any) => {
  const { columns, data } = param
  const sums: string[] = []
  columns.forEach((column: any, index: any) => {
    if (index === 0) {
      sums[0] = '合计'
      return
    }
    // const values = data.map((item: any) => Number(item[column.property]))
    // sums[index] = getNumber(summaryVo['sum' + column.property.charAt(0).toUpperCase() + column.property.slice(1)])
    let obj = dynamicTotal.value.find((project: any) => project.purpose === column.property)
    sums[index] = obj ? getNumber(obj.total) : '-'
  })

  return sums
}

return (_ctx: any,_cache: any) => {
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: searchHandle }), {
      btnGroup: _withCtx(() => [
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "请先搜索后，再导出",
          placement: "bottom"
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_eptBtn, {
              type: "primary",
              exportFn: _unref(exportApi),
              exportText: '导出',
              exportParam: _unref(MI_params)
            }, null, 8, ["exportFn", "exportParam"]), [
              [_directive_permission, 'Export']
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      "show-summary": "",
      "summary-method": getSummaries,
      ref: "tb",
      border: "",
      data: _unref(calculDate),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.realName + ' (' + row.alias + ')'), 1)
          ]),
          _: 1
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dynamicTotal), (project) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "right",
            key: project.purpose,
            label: project.purpose,
            formatter: (row) => formatProjectList(row, project),
            prop: project.purpose,
            "show-overflow-tooltip": ""
          }, {
            header: _withCtx(() => [
              _createVNode(_component_el_tooltip, {
                effect: "dark",
                content: project.purpose,
                placement: "top"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(project.purpose), 1)
                ]),
                _: 2
              }, 1032, ["content"])
            ]),
            _: 2
          }, 1032, ["label", "formatter", "prop"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[1] || (_cache[1] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})